'use strict';
var angular = require('angular');
var ProfessionalInfoService = /** @class */ (function () {
    function ProfessionalInfoService($http, Auth) {
        'ngInject';
        this._$http = $http;
        this.Auth = Auth;
        // Object to store our user properties
        this.current = null;
    }
    ProfessionalInfoService.prototype.handleSuccess = function (response) {
        return response;
    };
    ProfessionalInfoService.prototype.handleError = function (response) {
        return response;
    };
    ProfessionalInfoService.prototype.updateAccount = function (acctId, user) {
        this.Auth.clearAccountCache();
        var request = this._$http.put('api/account/' + acctId, user);
        return (request.then(this.handleSuccess, this.handleError));
    };
    return ProfessionalInfoService;
}());
export default ProfessionalInfoService;
//# sourceMappingURL=professional-info.service.js.map